import React from 'react';
import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Spinner,
  VStack,
} from '@chakra-ui/react';
import dayjs from 'dayjs';
import {PinkButton} from '../../button';
import {TextG12, TextG14, TextG16} from '../../typography';

const WarningTriangle = () => (
  <svg width={44} height={44} viewBox="0 0 44 44" fill="none">
    <path d="M22 5L42 39H2L22 5Z" fill="#F7C13B" />
    <rect x="20.5" y="17" width="3" height="11" rx="1.5" fill="#1B1413" />
    <circle cx="22" cy="33" r="1.8" fill="#1B1413" />
  </svg>
);

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onKeep: () => void;
  onContinue: () => void;
  resumeOnDate?: string;
  isLoading?: boolean;
};

const PauseConfirmModal = ({
  isOpen,
  onClose,
  onKeep,
  onContinue,
  resumeOnDate,
  isLoading = false,
}: Props) => {
  const formattedDate = resumeOnDate ? dayjs(resumeOnDate).format('MMMM D') : 'next month';

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg="rgba(20,20,30,0.45)" />
      <ModalContent w="90%" maxW="360px" borderRadius="22px" pt="28px" px="22px" pb="22px">
        <ModalBody p={0}>
          <VStack spacing={4} align="stretch">
            <Flex justify="center">
              <WarningTriangle />
            </Flex>
            <Box
              fontSize="22px"
              fontWeight="800"
              lineHeight="28px"
              color="#202020"
              textAlign="center"
              letterSpacing="-0.01em">
              You'll lose access to your membership
            </Box>
            <TextG16 color="#4D4D4D" lineHeight="24px" fontWeight="400">
              After <strong style={{color: '#202020'}}>{formattedDate}</strong>, you&rsquo;ll no
              longer have access to exclusive membership benefits.
              <Box as="p" mt={3}>
                Walkabout is constantly curating more connection and value for you in San Diego so
                keep checking back, saving what&rsquo;s interesting, and connecting with neighbors!
              </Box>
            </TextG16>
            <PinkButton
              h="52px"
              borderRadius="100px"
              width="100%"
              onClick={onKeep}
              boxShadow="0 -4px 0 0 rgba(0, 0, 0, 0.25) inset"
              isDisabled={isLoading}>
              <TextG16 fontWeight="500">Keep Membership</TextG16>
            </PinkButton>
            <TextG14 color="#4D4D4D" textAlign="center" mx="8px" fontWeight="500">
              Most members get the most value after their first month.
            </TextG14>
            <Flex justify="center" mt="2px">
              <Box
                as="button"
                onClick={onContinue}
                disabled={isLoading}
                bg="transparent"
                border="none"
                cursor={isLoading ? 'not-allowed' : 'pointer'}
                color="#262626"
                fontWeight={500}
                lineHeight="24px"
                textDecoration="underline"
                textUnderlineOffset="auto"
                p={1}
                opacity={isLoading ? 0.6 : 1}>
                {isLoading ? <Spinner size="sm" /> : <TextG16>Continue to cancel</TextG16>}
              </Box>
            </Flex>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PauseConfirmModal;
